import { BehaviorSubject } from 'rxjs';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

/**
 * interfaces
 */
import { IUserInfo } from 'src/app/core/interfaces/user/user-info';
import { IPaymentPlan } from 'src/app/core/interfaces/ads/payment-plan';
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

/**
 * services
 */
import { GlobleService } from 'src/app/core/services/globle.service';
import { AuthService } from 'src/app/core/services/user/auth.service';

@Component({
  selector: 'app-advertisement-payment-timeline',
  templateUrl: './advertisement-payment-timeline.component.html',
  styleUrls: ['./advertisement-payment-timeline.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvertisementPaymentTimelineComponent {

  /************  OutPuts  ************/
  /**
   * PayNowEventHandler
   * @description to emit click trigger for pay
   */
  @Output('payNow') public PayNowEventHandler: EventEmitter<void> = new EventEmitter<void>();    

  /************  Inputs  ************/
  /**
   * data
   * @description Advertisement Data
   */
  @Input({ alias: 'data', required: true }) public AdvertisementData: IAdvertisementResponse = null;  


  /************  Accessors  ************/  
  /**
   * UserInfo
   */
  public get UserInfo(): BehaviorSubject<IUserInfo> {
    return this._auth.userInfo
  }

  /**
   * IsOwner
   */
  public get IsOwner(): boolean {
    
    // ES6 Destruction
    const { owner: { id } } = this.AdvertisementData;

    /**
     * 
     */
    return this._g.CorrectUserId == id;

  }
  /**
   * Deposit
   */
  public get Deposit(): number {
    return this.AdvertisementData.deposit
  }

  /**
   * HasUserPaidDeposit
   */
  public get HasUserPaidDeposit(): any {

    // ES6 Destruction & Nested
    const { depositPaidUser: { id } = {} } = this.AdvertisementData;

    /**
     * 
     */
    return this._g.CorrectUserId == id

  }

  /**
   * Price
   */
  public get Price(): number {
    return this.AdvertisementData.price
  } 
  
  /**
   * PaymentPlan
   */
  public get PaymentPlan(): IPaymentPlan {
    return this.AdvertisementData.paymentPlan
  }

  /**
   * PaymentCountTitle
   */
  public get PaymentCountTitle(): string {
    
    // ES6 Destruction
    const { paymentsCount } = this.PaymentPlan || {};

    /**
     * init
     */
    const installments = ['دفعة واحده', 'دفعتين', 'ثلاث دفعات', 'اربع دفعات', 'خمس دفعات'];

    /**
     * get index
     */
    const installment = installments[paymentsCount - 1]

    /**
     * 
     */
    return installment ? installment : `${paymentsCount} دفعات`

  }

  /**
   * payments
   */
  public get Payments() {

    // ES6 Destruction
    const { payments } = this.PaymentPlan || {};

    /**
     * 
     */
    if (this.PaymentPlan != null && Array.isArray(payments) && payments.length > 0) return payments;

    /**
     * handler null value
     */
    return []

  }

  /**
   *
   */
  constructor(
    private _g: GlobleService,
    private _auth: AuthService,
  ) {}

  /************  Methods  ************/ 
  /**
   * 
   * @param index 
   * @returns 
   */
  public InstallmentTitle(index: number): string | number {

    /**
     * 
     */
    const titles = ['الاولي', 'الثانية', 'الثالثة', 'الاخيره', 'الرابعة', 'الخامسة'];

    /**
     * 
     */
    return titles[index] ? titles[index] : `( ${index + 1} )`

  }  

  /**
   * PayNow
   */
  public PayNow(): void {
    this.PayNowEventHandler.emit()
  }

}
